import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import { Provider } from 'react-redux'; 
import {unregister} from './registerServiceWorker';
import { store } from './_helpers'  
import './App.css';
import './Spacing.css'

ReactDOM.render(
    <Provider store = { store }>
        <App />
    </Provider>, document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js